var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-custom"},[_c('Breadscrumbs',{attrs:{"links":[
      { name: 'Email Alerts',
        to: {
          name: 'EmailAlerts'
        }
      },
      { name: 'Edit',
        to: {
          name: 'EmailAlertsInfoEdit',
          params: {
            id: _vm.$route.params.id,
          }
        },
      } ]}}),_c('div',{staticClass:"page-actions"},[_c('h2',[_vm._v("Subscriber Edit")]),_c('v-spacer'),_c('button',{staticClass:"btn mr-5",on:{"click":_vm.cancelHandler}},[_vm._v("取消")]),_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.saveHandler}},[_vm._v("儲存")])],1),_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.saveHandler.apply(null, arguments)}}},[_c('EmailAlertsInfoCreateEdit')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }